import { useEffect, useState } from "react";
import AceEditor from "react-ace";
import styles from "./styles.module.css";
import Validate from "./validator";
export default function SampleResponse({ webhook, onChange }) {
  const [value, setValue] = useState("");
  const [validate, setValidate] = useState(null);
  const handleChange = (v) => {
    setValue(v);
  };

  useEffect(() => {
    setValue(webhook.sampleResponse);
  }, [webhook.sampleResponse]);

  const onBlur = () => {
    const _webhook = { ...webhook };

    _webhook.sampleResponse = value;
    onChange(_webhook);
  };

  const handleValidate = () => {
    try {
      const data = JSON.parse(value);
      setValidate({ data, webhook });
    } catch (err) {
      setValidate({ err: true, webhook });
    }
  };

  const handleSaveValidation = (schema, webhook) => {
    const _webhook = { ...webhook };
    _webhook.schema = schema;
    onChange(_webhook);
    setValidate(null);
  };
  return (
    <div style={{ marginTop: 20 }}>
      <AceEditor
        mode="json"
        theme="tomorrow"
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        name="bodyDiv"
        debounceChangePeriod={300}
        editorProps={{ $blockScrolling: true }}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: false,
          showLineNumbers: true,
          tabSize: 2,
        }}
        style={{ width: "100%", height: 200, border: "1px solid #E0E0E0" }}
      />
      {!webhook.schema.name ? (
        <button
          onClick={handleValidate}
          style={{ marginTop: 20 }}
          className={styles.validateButton}
        >
          Validate
        </button>
      ) : (
        <button
          onClick={handleValidate}
          style={{ marginTop: 20 }}
          className={styles.validateButton + " " + styles.verified}
        >
          Re-validate
        </button>
      )}

      <Validate
        onSave={handleSaveValidation}
        setValidate={() => setValidate(null)}
        validate={validate}
      />
    </div>
  );
}
